// function to scroll to the content when clicking on a menu item

const scrollToContent = ($) => {
	$(".menu-item:not(.menu-item-has-children) > a").on("click", function (event) {
		// prevent the default link behavior
		event.preventDefault();

		// get the target ID from the href attribute
		const targetId = $(this).attr("href").substring(1);
		const targetElement = $("#" + targetId); // Select the target element
		const header = $("#header");
		const body = $("body");

		// close the header menu if it's open
		if (header.hasClass("js-open-menu")) {
			header.removeClass("js-open-menu");
			body.toggleClass("menu-open");
			header.css('overflow', 'unset');
		} else {
			header.addClass("js-open-menu");
			body.toggleClass("menu-open");
			header.css('overflow-y', 'scroll');
		}

		// smooth scroll to the target element
		$('html, body').animate({
			scrollTop: targetElement.offset().top
		}, 600);
	});
};

export default scrollToContent;
